import { Field } from '@lmt/unicorn-shared/app/components/common/Field';
import { FieldBlock } from '@lmt/unicorn-shared/app/components/common/FieldBlock';
import { CheckBox } from '@lmt/unicorn-shared/app/components/common/ui-kit/CheckBox';
import { Input } from '@lmt/unicorn-shared/app/components/common/ui-kit/inputs/Input';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React, { FC } from 'react';
import { HL7SettingsFormProps } from './types';

import styles from './../SettingsBlock.module.scss';

export const HL7OutgoingSettingsBlock: FC<HL7SettingsFormProps> = (props) => {
  const i18next = useScopedTranslation('tenant_settings.hl7.outgoing');

  const { register, formState, setValue, watch } = props.form;

  const [isHl7OutgoingEnabled] = watch(['isHl7OutgoingEnabled']);

  return (
    <div className={styles.blockContainer}>
      <FieldBlock
        title={i18next.t('outgoing_settings')}
        className={styles.fieldBlock}
      >
        <div
          className={styles.row}
          data-test-id="outgoing-transporter-checkbox"
        >
          {props.isServerEnabled && (
            <CheckBox
              title={i18next.t('enabled')}
              className={styles.checkbox}
              {...register('isHl7OutgoingEnabled')}
              onChange={(e) => {
                setValue('isHl7OutgoingEnabled', e.currentTarget.checked, {
                  shouldDirty: true,
                });
                if (e.currentTarget.checked) {
                  setValue('outgoingTransporterEnabled', false, {
                    shouldDirty: true,
                  });
                }
              }}
            />
          )}
          <CheckBox
            title={i18next.t('outgoing_transporter_enabled')}
            className={styles.checkbox}
            {...register('outgoingTransporterEnabled')}
            onChange={(e) => {
              setValue('outgoingTransporterEnabled', e.currentTarget.checked, {
                shouldDirty: true,
              });
              if (e.currentTarget.checked) {
                setValue('isHl7OutgoingEnabled', false, {
                  shouldDirty: true,
                });
              }
            }}
          />
        </div>
        {props.isServerEnabled && (
          <>
            <Field title={i18next.t('server_address')} className={styles.field}>
              <Input
                disabled={!isHl7OutgoingEnabled}
                variant="normal"
                {...register('serverAddress')}
                errorText={formState.errors.serverAddress?.message}
              />
            </Field>
            <Field title={i18next.t('server_port')} className={styles.field}>
              <Input
                disabled={!isHl7OutgoingEnabled}
                variant="normal"
                {...register('serverPort')}
                errorText={formState.errors.serverPort?.message}
              />
            </Field>
            <Field title={i18next.t('retry_delays')} className={styles.field}>
              <Input
                disabled={!isHl7OutgoingEnabled}
                variant="normal"
                {...register('retryDelays')}
                errorText={formState.errors.retryDelays?.message}
              />
            </Field>
            <Field title={i18next.t('files_directory')}>
              <Input
                disabled={!isHl7OutgoingEnabled}
                variant="normal"
                {...register('filesDirectory')}
                errorText={formState.errors.filesDirectory?.message}
              />
            </Field>
          </>
        )}
      </FieldBlock>
    </div>
  );
};
